var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form-item',{key:_vm.item.column,attrs:{"label":_vm.item.display,"prop":_vm.item.column}},[_c('el-row',{attrs:{"type":"flex"}},[_c(_vm.fieldComs[_vm.item.componentType],{tag:"component",style:({
        width: _vm.comWidth
      }),attrs:{"item":_vm.item,"value":_vm.$_value},on:{"update:value":function($event){_vm.$_value=$event}}}),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }